import { Fragment } from "react";
import "./ProductSection.css";
import LeftVisual from "./LeftVisual";

const ProductSection = () => {
  return (
    <Fragment>
      <section className="product-section">
        <div className="container">
          <div
            className="section-title"
            data-aos="fade-down"
            data-aos-duration="800"
          >
            <div className="text-uppercase">our products</div>
            <h4 className="text-uppercase">
              Will Happy to Showing Our Products
            </h4>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 d-none d-sm-none d-md-block d-lg-block">
              <LeftVisual />
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="align-self-center">
                <div className="product-item">
                  <span className="icon">⚡</span>
                  <a href="https://www.kairaaexchange.com/" target="black">Kairaa Exchange</a>
                </div>
                <div className="product-item">
                  <span className="icon">🪙</span>
                  <a href="https://kairaablockchainacademy.com/" target="black">Kairaa Blockchain Academy</a>
                </div>
                <div className="product-item">
                  <span className="icon">🔐</span>
                  <a href="https://www.kaitcoin.org/auth/signin" target="black">Kait Staking</a>
                </div>
                <div className="product-item">
                  <span className="icon">📊</span>
                  <a href="https://kaitcoin.com/" target="black">Kait Coin</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default ProductSection;
